import React from 'react';
import { NavigationMenu } from './Navigation';
import styled from 'styled-components';
import { useUser } from '@clerk/clerk-react';
import { PageLoader } from './PageLoader';
const MainContainer = styled.div.attrs({
    className: 'main-container'
}) `
  min-height: 100vh;
  background-color: var(--background-color);
  color: var(--text-color);
`;
export const Layout = ({ children }) => {
    const { isLoaded, isSignedIn, user } = useUser();
    if (!isLoaded) {
        return React.createElement(PageLoader, { text: "Loading..." });
    }
    return (React.createElement(MainContainer, null,
        React.createElement(NavigationMenu, null),
        React.createElement("div", null, children)));
};
